import React, { useRef } from 'react'

import { Button, Icon, colors as zetColors } from '@zet/design-system'
import { i18n } from '@zet/localization'

import { IBrandComsData } from '../../api/brands/types'

interface Props {
  eventPayload: any
  handlePress: (isSkipShareContentARNBottomsheet?: boolean) => void
  isLoading: boolean
  content?: IBrandComsData
  params: any
  customerData: any
  isWhatsappRef: ReturnType<typeof useRef<boolean>>
}
export const WhatsappShareButton = (props: Props) => {
  const {
    handlePress,
    isLoading,
    content,
    params,
    isWhatsappRef,
    customerData,
  } = props

  const onWhatsappShareClick = () => {
    isWhatsappRef.current = true
    handlePress()
  }

  return (
    <Button
      intent="success"
      size={'lg'}
      className="ml-2 flex-1"
      numberOfLines={1}
      onPress={onWhatsappShareClick}
      eventName={'click_action'}
      eventPayload={{
        item_name: params?.customerId
          ? 'brands_list_recommendation_whatsapp_share'
          : 'brands_list_whatsapp_share',
        brand_name: content?.name,
        brand_category: content?.subCategory,
        customer_id: params?.customerId,
      }}
      loading={isLoading}
      iconLeft={
        <Icon type="Whatsapp" size={24} color={zetColors.neutral.white100} />
      }
    >
      {customerData?.fullName
        ? i18n.t('shareCardLink.shareCta', {
            name: customerData?.fullName,
          })
        : i18n.t('webFlowApplyModal.shareTitle')}
    </Button>
  )
}
